module.exports = __webpack_public_path__ + "static/media/  (148).7b283f98.jpg";